export default __webpack_public_path__ + "static/media/Recive.34936445.svg";